import { Component, input } from "@angular/core";

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: "a[vo-navigation-button]",
    templateUrl: "./navigation-button.html",
    styleUrl: "./navigation-button.css",
    host: {
        class: "nav-link",
        "[class.nav-link--active]": "isActive()"
    },
    exportAs: "voNavigationAnchor"
})
export class VoNavigationAnchorComponent {
    public isActive = input<boolean>(false);
}

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: "button[vo-navigation-button]",
    templateUrl: "./navigation-button.html",
    styleUrl: "./navigation-button.css",
    host: {
        class: "nav-link",
        "[class.nav-link--active]": "isActive()"
    },
    exportAs: "voNavigationButton"
})
export class VoNavigationButtonComponent {
    public isActive = input<boolean>(false);
}
